export default __webpack_public_path__ + "static/media/icon-head-capra.3ec2b9eb.png";